import { useContext } from 'react';

import { GlobalContext } from "../../../contexts/globalContext";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { byPrefixAndName } from '@awesome.me/kit-fe6b9b7683/icons';

import styles from './YearComponent.module.css'


const YearComponent = ({ selectedDate, setSelectedDate, setChangedYear }) => {

    const { setAlertMessage } = useContext(GlobalContext);

    const currentDate = new Date();

    function compareYear() {
        if (selectedDate?.getFullYear() > currentDate.getFullYear())
            return 1
        return 0
    }

    function onClickLeft() {
        if (compareYear()) {
            let newDate = new Date(selectedDate)
            newDate.setFullYear(newDate.getFullYear() - 1)
            setSelectedDate(newDate)
            setChangedYear(true)
        } else {
            setAlertMessage({ type: "ERROR", message: `The selected year is in the past.` });
        }
    }

    function onClickRight() {
        let newDate = new Date(selectedDate)
        newDate.setFullYear(newDate.getFullYear() + 1)
        setSelectedDate(newDate)
        setChangedYear(true)
    }

    return (
        <>
            <div className={styles.sectionName}>
                Date
            </div>
            <div className={styles.selectionYear}>
                <div className={styles.changeYear} style={{ opacity: compareYear() ? 1 : 0.5 }} onClick={onClickLeft}>
                    <FontAwesomeIcon icon={byPrefixAndName.fas['chevron-left']} />
                </div>
                <div className={styles.selectedYear}>
                    {selectedDate?.getFullYear()}
                </div>
                <div className={styles.changeYear} onClick={onClickRight}>
                    <FontAwesomeIcon icon={byPrefixAndName.fas['chevron-right']} />
                </div>
            </div>
        </>
    );

}

export default YearComponent;